import './LiveCounterButton.sass';

import React, { FC, useEffect, useRef } from 'react';
import { LiveCounterButtonProps } from './LiveCounterButton.interface';
import { classNames as cn } from '$utils';

export const LiveCounterButton: FC<LiveCounterButtonProps> = ({
  children,
  style = 'default',
  icon,
  minWidth,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn('LiveCounterButton', style, {
        active: onClick,
      })}
      style={{ minWidth: `${minWidth}px` }}
    >
      {!!icon && <div className="LiveCounterButton__icon">{icon}</div>}
      <span>{children}</span>
    </div>
  );
};
